var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { loadScript } from '@ifeng-fe/ui_base';
/**
 * 广告加载事件：解析广告信息，返回广告回调方法
 * @param { object } ad
 */
function handleAd(ad) {
    return __awaiter(this, void 0, void 0, function () {
        var callbackFn, preloadList, index, scriptUrl, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    callbackFn = undefined;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    if (!ad.preload) return [3 /*break*/, 4];
                    preloadList = typeof ad.preload === 'string' ? [ad.preload] : ad.preload;
                    index = 0;
                    _a.label = 2;
                case 2:
                    if (!(preloadList.length > index)) return [3 /*break*/, 4];
                    scriptUrl = preloadList[index];
                    return [4 /*yield*/, loadScript(scriptUrl, {
                            cache: false,
                            reload: false
                        })];
                case 3:
                    _a.sent();
                    index += 1;
                    return [3 /*break*/, 2];
                case 4:
                    /* eslint-disable */
                    callbackFn = new Function("return " + ad.callback)();
                    return [3 /*break*/, 6];
                case 5:
                    err_1 = _a.sent();
                    err_1.message = "AdError - " + err_1.message;
                    console.error(err_1);
                    console.error('AdError - AdData', ad);
                    if (window && window['BJ_REPORT'])
                        window['BJ_REPORT'].report(err_1); // 错误上报
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/, callbackFn];
            }
        });
    });
}
export default handleAd;
